import React from "react";
import { STATUS_META } from "@/lib/constants";

export const StatusBadge = ({ status, className = "" }) => {
  const meta = STATUS_META[status] || { label: status, dot: "#6B6673" };
  return (
    <span
      data-testid="status-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border border-[color:var(--brand-border)] bg-white px-2.5 py-1 text-xs font-medium text-[color:var(--brand-graphite)] ${className}`}
    >
      <span className="h-2 w-2 rounded-full" style={{ background: meta.dot }} />
      {meta.label}
    </span>
  );
};
